import React from 'react'
import PropTypes from 'prop-types'
import SearchBarView from './searchBarView';
import SearchResultsView from './searchResultsView'
import LocationSuggesiontsDataSource from 'dataSource/locationSuggestionsDataSource'
import 'styles/location-finder.css'
import Utils from 'common/utils';
import NativeAgent from 'common/nativeAgent'
import CommonComponents from 'components/commonComponents'
import Constants from 'common/constants'
import Analytics from 'analytics';

const LOG_PREFIX = "[LOC-FINDER] "

export default class LocationFinderView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            locationResults: null,
            queryVal: null,
            isSearching: false,
        }
    }

    componentDidMount() {
        // Disable pull to refresh
        NativeAgent.updatePullToRefresh(false)

        // Update analytics
        Analytics.trackPageView(Constants.ANALYTICS.PAGE_VIEW.LOCATION_FINDER_PAGE)
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.COMP_LOAD,
            Constants.ANALYTICS.EVENTS.ACTION.COMP_LOCATION_FINDER,
            null,
            null,
            true,
        )
    }

    render() {
        let marginBottomClass = ""
        if (false === CommonComponents.shouldSetBottomBar()) {
            marginBottomClass = "overlay-without-bottom-bar"
        } else {
            marginBottomClass = "overlay-with-bottom-bar"
        }

        let searchIconName = "search-icon"
        if (this.state.isSearching) {
            searchIconName = "search-loader"
        }

        return (
            <div>
                <div className={"location-finder-overlay-wrapper fadeInUp " + marginBottomClass}>
                    <div className="search-input-wrapper">
                        <span className="icon-search">
                            <img src={`/image/${searchIconName}.svg`} alt={searchIconName} />
                        </span>
                        <SearchBarView
                            queryChangedCb={this.makeRequestForQuery.bind(this)}
                        />
                        <button
                            className="close-btn"
                            onClick={() => { this.props.back_press_callback() }}
                        >
                            <img src="/image/close-icon-gray.svg" alt="close_icon" />
                        </button>
                    </div>
                    <SearchResultsView
                        searchQuery={this.state.queryVal}
                        locationResults={this.state.locationResults}
                        onSelectedLocationCallback={(selectedLocation) => {
                            if (Utils.isNull(selectedLocation)) {
                                console.log(LOG_PREFIX, "Got empty location value on selection")
                                return
                            }
                            this.props.on_location_selected(selectedLocation)
                        }}
                    />
                </div>
            </div>
        )
    }

    async makeRequestForQuery(queryVal) {
        this.setState({ isSearching: true })
        let locSuggestions = null

        // Make a query only if the query-value is present
        if (false === Utils.isEmptyStr(queryVal)) {
            console.log(LOG_PREFIX, "Got query - ", queryVal)
            try {
                locSuggestions = await LocationSuggesiontsDataSource.getSuggestionsForLocation(queryVal)
            } catch (err) {
                console.log(LOG_PREFIX, "Error fetching data - ", err)
            }
        }

        this.setState({
            locationResults: locSuggestions,
            queryVal: queryVal,
            isSearching: false,
        })
    }
}

LocationFinderView.propTypes = {
    back_press_callback: PropTypes.func.isRequired,
    on_location_selected: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/locationFinder/locationFinderView.js